import { cn } from "@/lib/utils";
import { AnimatedNumber } from "@/components/motion-primitives/animated-number";

export const BinaryRating = ({
  title,
  up,
  down,
}: {
  title: string;
  up: number;
  down: number;
}) => {
  const empty = up === 0 && down === 0;
  return (
    <div
      className={cn(
        "flex w-full flex-col gap-1 md:flex-row md:items-center md:justify-between md:gap-4",
      )}
      key={title}
    >
      <h4 className={cn("text-sm", empty ? "text-zinc-300" : "text-zinc-950")}>
        {title}
      </h4>
      <div
        className={cn(
          "inline-flex items-center gap-1 text-base text-xs",
          empty && "text-zinc-300",
        )}
      >
        <div
          className={cn(
            "font-bold whitespace-nowrap",
            up > 0 && "text-remedium-blue",
            up > 0 && down > up && "text-zinc-500",
            up === 0 && "text-zinc-300",
          )}
        >
          Tak (<AnimatedNumber value={up} />)
        </div>
        <span className={"font-medium text-zinc-200"}>|</span>
        <div
          className={cn(
            "font-bold whitespace-nowrap",
            down > 0 && "text-remedium-blue",
            down > 0 && up > down && "text-zinc-500",
            down === 0 && "text-zinc-300",
          )}
        >
          Nie (<AnimatedNumber value={down} />)
        </div>
      </div>
    </div>
  );
};
